<template>
  <ui-drawer
    class="left-0 z-[7] rounded rounded-r md:rounded-r"
    :class="{ 'bottom-2 right-2 top-2': !session.features.zendeskUiNavigation }"
    :active="helpDrawerActive"
    max-width="360px"
    narrow
    @close="closeHelpDrawer"
  >
    <template #header>
      <header class="flex h-16 items-center gap-2 py-5">
        <ui-button v-if="isActiveChildRoute" class="shrink-0" secondary small borderless @click="backToParent">
          <arrow-left-icon class="icon-m" />
        </ui-button>
        <h2 class="text-gray-90 grow truncate text-center text-base font-semibold">{{ activeView?.title }}</h2>
        <ui-button class="shrink-0" secondary small borderless @click="closeHelpDrawer">
          <x-icon class="icon-m" />
        </ui-button>
      </header>
    </template>
    <component :is="activeView?.content" />
  </ui-drawer>
</template>

<script setup lang="ts">
import { UiDrawer, UiButton } from '@klausapp/ui-kit'
import { XIcon, ArrowLeftIcon } from '@klausapp/ui-kit/icons'
import { session } from '@/composables/useSession'

import useHelpDrawer from './composables/useHelpDrawer'

const { helpDrawerActive, activeView, backToParent, isActiveChildRoute } = useHelpDrawer()

function closeHelpDrawer() {
  helpDrawerActive.value = false
}
</script>
